<script>
import widgetWrapper from '@/components/widgets/common/widgetWrapper';
import {h, resolveComponent} from "vue";

export default {
  name: 'widgetDesc',
  components: {widgetWrapper},
  emits: ['more'],
  render() {
    const {$theme, items} = this;
    const {title, subtitle, dateItem, more, info} = items;
    const widgetWrapper = resolveComponent('widget-wrapper');

    const widgetDesc = h('div', {class: 'widget-desc'}, [
      h('div', {class: 'widget-desc-name'}, [items.name]),
      items.desc,
    ]);

    return h(
        widgetWrapper,
        {
          title, subtitle, dateItem, more, info,
          onMore: more => {
            this.$emit('more', more);
          },
        },
        () => [widgetDesc],
    );
  },
  methods: {},
  props: {
    items: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.widget-desc {
  height: 100%;
  margin: 0 auto;
  padding: 29px 40px;
  display: flex;
  flex-direction: column;
  white-space: pre-wrap;
  word-wrap: break-word;
  @include font(16px);

  &-name {
    @include font(20px, 700);
    padding-bottom: 8px;
  }
}
</style>
